import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Box from "@mui/material/Box";

const Teams = lazy(() => import("../Teams/Teams"));

export const Club = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Routes>
        <Route path="/teams/*" element={<Teams />} />
      </Routes>
    </Box>
  );
};

export default Club;
